import { Box, Modal, Typography, Button } from "@mui/material";

interface UserLoggedoutModalProps {
    open: boolean;
    onClose: () => void;
}

export const UserLoggedoutModal = ({ open, onClose }: UserLoggedoutModalProps) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        borderRadius: '12px',
        boxShadow: 24,
        p: 4,
        textAlign: 'center' as const,
        outline: 'none'
    };

    return (
        <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2" fontWeight={700} gutterBottom>
                    Session Expired
                </Typography>
                <Typography id="modal-modal-description" color="text.secondary" sx={{ mt: 1, mb: 4 }}>
                    Your session has expired or your access was denied. Please log in again to continue.
                </Typography>
                <Button variant="contained" size="large" onClick={onClose} fullWidth sx={{ borderRadius: '8px' }}>
                    Go to Login
                </Button>
            </Box>
        </Modal>
    );
};